<template>
  <Menu.Root id="header-dropdown">
    <Menu.Trigger>
      <HeaderAction :label="label" icon="ellipsis-horizontal" />
    </Menu.Trigger>

    <Menu.Container>
      <slot></slot>
    </Menu.Container>
  </Menu.Root>
</template>

<script setup lang="ts">
import Menu from "@/design_system/Menu";

import HeaderAction from "./HeaderAction.vue";

withDefaults(
  defineProps<{
    label?: string;
  }>(),
  {
    label: `Actions`,
  }
);
</script>
